import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

const api = API('/api/onDemandDeadlineSettings.v1', { type: 'rest' });

/* eslint-disable no-console */
const deadlinesApiUtils = {
  getStartTime(courseId: $TSFixMe) {
    const uri = new URI()
      .addQueryParam('q', 'byUserAndCourse')
      .addQueryParam('userId', user.get().id)
      .addQueryParam('courseId', courseId)
      .toString();

    return Q(api.get(uri)).fail(function (error) {
      console.error(error);
    });
  },

  sendStartTime(deadlinesEnabled: $TSFixMe, courseId: $TSFixMe) {
    const options = {
      data: {
        userId: user.get().id,
        courseId,
        start: Date.now(),
        isEnabled: deadlinesEnabled,
      },
    };

    return Q(api.post('', options));
  },
};

export default deadlinesApiUtils;

export const { getStartTime, sendStartTime } = deadlinesApiUtils;
